import React, { Component } from 'react';
import { Button } from 'reactstrap';

/* Import components */
import RadioButtonGroup from '../components/RadioButtonGroup';
import LoadingSpinner from '../components/LoadingSpinner';

class ComplianceFormContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitError: '',
      compliance: {
        protocol: props.compliance.protocol,
        verified: props.compliance.verified
      },
      errors: {
        protocol: { text: 'Protocol response is required', value: 'has-error' }
      },
      protocolOptions: [ 'Yes', 'No' ],
      valueUpdated: false,
      loading: false
    };

    this.handleInput = this.handleInput.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormClose = this.handleFormClose.bind(this);
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      prevState => ({
        compliance: {
          ...prevState.compliance,
          [name]: value.localeCompare('yes', 'en', { sensitivity: 'base' }) === 0
        },
        errors: {
          ...prevState.errors,
          [name]: { text: '', value: '' }
        },
        valueUpdated: true
      }), () => console.log(this.state.compliance)
    );
  }

  handleFormClose = e => {
    e.preventDefault();
    window.location = `https://microsoft.visualstudio.com/os/_git/os.2020/pullrequest/${this.props.changeId}`
  }

  handleFormSubmit = e => {
    e.preventDefault();
    this.setState(
      prevState => ({
        ...prevState,
        loading: true,
        submitError: ''
      }), () => console.log(this.state.compliance)
    );

    const postComplianceUrl = `https://compliance-service.azurewebsites.net/api/compliance/${this.props.bugId}/tags`;
    const postObject = { protocol: this.state.compliance.protocol };

    fetch(postComplianceUrl, {
      method: 'POST',
      body: JSON.stringify(postObject),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if(response.status === 204) {
        this.handleError(new Promise(function(resolve) { resolve("Could not find work items with the given id to update")}));
        throw Error("Could not find work items with the given id to update");
      } else if(response.status !== 200) {
        this.handleFormError(response.json());
        throw Error(response.statusText);
      }

      return response.json();
    }).then(data => {
      window.location = `https://microsoft.visualstudio.com/os/_git/os.2020/pullrequest/${this.props.changeId}`;
    }).catch(error => {
      this.setState(
        prevState => ({
          ...prevState,
          loading: false,
          submitError: error
        }), () => console.log(this.state.compliance)
      );
      console.log(error);
    });
  }

  handleFormError = response => {
    response.then(error => {
      this.setState(
        prevState => ({
          ...prevState,
          loading: false,
          submitError: error
        }), () => console.log(this.state.compliance)
      );

      console.log(error);
    });
  }

  isSubmitDisabled = compliance => {
    var allValuesFilled = Object.values(compliance).every((v) => { return typeof(v) === typeof(true || false); });
    if(this.state.valueUpdated && allValuesFilled) {
      return false;
    }

    if(compliance.verified) {
      //Disable submit on verified compliance (which will change if values change)
      return true;
    }

    // If not verified, disable form submit unless every value is boolean type
    return !allValuesFilled;
  }

  getSubmitButtonTooltip = compliance => {
    if(compliance.verified) {
      return 'Change values to enable update';
    }

    if (!Object.values(compliance).every((v) => { return typeof(v) === typeof(true || false); })) {
      return 'Please answer all questions';
    }

    return '';
  }

  render() {
    const { loading, submitError } = this.state;
    if (loading)
      return <LoadingSpinner />

    if (submitError !== '') {
      alert(submitError);
    }

    return (
      <form className='container-fluid' onSubmit={this.handleFormSubmit}>
        <div className="row">
          <div className="col-md-8">
            <RadioButtonGroup
              title={'1. Does this change add new or change existing communication protocols?'}
              link={'https://osgwiki.com/wiki/CSD_Wiki-CSD_Compliance_Signoff#Protocols'}
              name={"protocol"}
              options={this.state.protocolOptions}
              handleChange={this.handleInput}
              validationState={this.state.errors.protocol.value}
              initialValue={this.props.compliance.protocol}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <br />
            <Button
              title={this.getSubmitButtonTooltip(this.state.compliance)}
              onClick={this.handleFormSubmit}
              style={{margin: '0px 10px 0px 10px'}}
              color={this.isSubmitDisabled(this.state.compliance) ? 'secondary' : 'success'}
              block
              disabled = {this.isSubmitDisabled(this.state.compliance)}
            >
              {this.state.compliance.verified ? 'Update' : 'Submit' }
            </Button>
          </div>
          <div className="col-md-1">
            <br />
            {this.state.compliance.verified
              ?
              <Button
                onClick={this.handleFormClose}
                style={{margin: '0px 10px 0px 10px'}}
                color="danger"
                block
              >
                Close
              </Button>
              :
              null
            }
          </div>
        </div>
      </form>
    );
  }
}

export default ComplianceFormContainer;